<template>
  <div class="success">
    <div class="headImgs">
      <img src="../../assets/imgs/apply/market.png" />
    </div>
    <div>苏州市级目录</div>
  </div>
</template>

<script>
export default {};
</script>

<style>
</style>